var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.123,
    height: 28.15,
    viewBox: "0 0 28.123 28.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2239",
    "data-name": "Group 2239",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1325",
    "data-name": "Path 1325",
    d: "M106.18,90.756a1.956,1.956,0,0,1-1.979,1.95H88.542a1.956,1.956,0,0,1-1.979-1.95V75.039a1.975,1.975,0,0,1,1.979-1.95h8l2.532-2.532H88.542A4.515,4.515,0,0,0,84,75.039V90.756a4.521,4.521,0,0,0,4.54,4.511H104.23a4.521,4.521,0,0,0,4.54-4.511V80.191l-2.532,2.532v8.033Z",
    transform: "translate(-84.002 -67.618)",
    fill: "#b1b1b1",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1326",
    "data-name": "Path 1326",
    d: "M234.184,18.133l-3.551-3.522A2.057,2.057,0,0,0,229.207,14a1.978,1.978,0,0,0-1.426.582l-13.1,13.1a2.013,2.013,0,0,0-.582,1.31l-.233,3.754a2.08,2.08,0,0,0,.582,1.572,2.027,2.027,0,0,0,1.426.582h.116l3.784-.232a2.013,2.013,0,0,0,1.31-.582l13.068-13.068a2.027,2.027,0,0,0,.582-1.426,1.908,1.908,0,0,0-.553-1.455Zm-8.353,2.008,2.823,2.823-6.549,6.52-2.823-2.823Zm-6.4,12.02-3,.175.175-3,.844-.844,2.823,2.823Zm11-11.031-2.794-2.794,1.572-1.572,2.823,2.823Z",
    transform: "translate(-207.116 -14)",
    fill: "#b1b1b1",
    stroke: "#fff",
    strokeWidth: 0.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.ac6671ce8bd75c8ee04f2c8468d6fc8f.svg";
export { ForwardRef as ReactComponent };